import { inject } from '@angular/core';
import {catchError, throwError} from 'rxjs';
import { OfflineStorageService } from './OfflineStorageService.service';
import type { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';

export const OfflineInterceptor: HttpInterceptorFn = (req, next) => {
    const offlineStorageService = inject(OfflineStorageService);
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            const isServerError = !error.status || (error.status >= 500 && error.status < 600);
            ///error.status === 0 отсутвие связи
            if (req.method !== 'GET' &&
                (error.status === 0 || isServerError)
            ) {
                offlineStorageService.saveOfflineRequest(req);
            }
            return throwError(() => error);
        })
    );
};

